export const overPerBuyerLimit = (ticketCount, limit) => limit != null && ticketCount > limit;
